import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8.604",
  cy: "5.75241",
  r: "3.5",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.104 15.1476C2.104 12.9384 3.89487 11.1476 6.104 11.1476H11.104C13.3131 11.1476 15.104 12.9384 15.104 15.1476V17.1476C15.104 18.0312 14.3877 18.7476 13.504 18.7476H3.704C2.82035 18.7476 2.104 18.0312 2.104 17.1476V15.1476Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.1453 17.8415V13.4415C18.1453 11.7847 16.8021 10.4415 15.1453 10.4415V10.4415",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.7452 8.17781C14.5822 7.69368 15.1452 6.7888 15.1452 5.75241C15.1452 4.71601 14.5822 3.81113 13.7452 3.327",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }